import { useQuery } from "@tanstack/react-query";
import { api } from "../../api";

export function useListUserGroupMembers(groupId: string | undefined) {
  return useQuery({
    queryKey: ["user-groups", groupId, "members"],
    queryFn: () => api.listUserGroupMembers(groupId!),
    enabled: !!groupId,
  });
}
